import { GradientProgress } from '@components/gradient-progress'
import Stack from '@mui/material/Stack'

export const PageFallback = () => (
  <Stack
    sx={{
      flexGrow: 1,
      height: 1,
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <GradientProgress size={26} thickness={5} />
  </Stack>
)
